import React from 'react';
import classes from './Answer.module.scss';

import {connect} from "react-redux";

const answer = ( props ) => {

    let QuestionsData = require( '../../../data/' + props.mode + '-questions.js' );

    let addClasses = [];

    if( props.isSelectedAnswer ) {
        addClasses.push( classes.Active );
    }

    const buttonClass = ( props.isSelectedAnswer ) ? [classes['Border-'+QuestionsData[props.version][props.questionIndex].color_scheme],classes['FG-'+QuestionsData[props.version][props.questionIndex].color_scheme]].join(' ') : null;

    return (
        <div className={[classes.Answer,...addClasses].join(' ')}>
            <button key={props.answerIndex}
                    onClick={() => props.onChooseAnswer(props.answerIndex)}
                    className={buttonClass}
            >{props.children}</button>
        </div>
    );

};

const mapStateToProps = state => {
    return {
        mode: state.mode
    }
};

export default connect( mapStateToProps )( answer );
